import { useEffect, useState } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { IntegracionService } from "../../../../../services/auxiliar/IntegracionService";
import { codigosRespuesta, IResponseApiFluent } from "../../../../../Interfaces/base/IResponse";

export const UsePanelRazonModeloSync=(props:IOpenPanel)=>{
     const [status, setStatus] = useState<codigosRespuesta>(0);
        const [mensaje, setMensaje] = useState<string>("");
        const [loading,setLoading]=useState<boolean>(false)
    useEffect(()=>{
        if(props.isOpen){
            Sincronizar()
        }    
    },[props.isOpen])
    const reset=()=>{
        setMensaje("")
        setStatus(0)
        props.onDismiss()
    }
    const Sincronizar=()=>{ 
        setLoading(true)
        IntegracionService.ActualizarRazonesModelos().then((res)=>
            {
                if(res.status==200){
                    setMensaje(res.data.mensaje)
                    setStatus(200)
                    setLoading(false)
                    setTimeout(() => {
                        props.reload?.();
                        reset()
                    }, 3000)
                }else{
                    setStatus(500)
                    setLoading(false)

                }

            }).catch((e)=>{
                if (
                                e.response?.data &&
                                'type' in e.response.data &&
                                'title' in e.response.data &&
                                'status' in e.response.data &&
                                'instance' in e.response.data &&
                                'errors' in e.response.data
                              ) {
                                const errorResponse = e.response.data as IResponseApiFluent;
                                const mensajeError = errorResponse.errors.join('\n');
                                setMensaje(mensajeError);
                              } else {
                                console.log('Error detallado:', e);
                                setMensaje("Error Inesperado");
                              }
                              setStatus(500);
                              setLoading(false)
            })
    }
    return {status,mensaje,loading,Sincronizar,reset}
}